import{jsx as o,jsxs as t}from"react/jsx-runtime";import r from"styled-components";import{useTranslation as i}from"react-i18next";import e from"../../../../../assets/profileSettingsWhatsApp/android/block-icon.svg.js";import{Wrapper as n}from"./styled.js";const m=r.div`
  opacity: 0.2;
  display: flex;
  align-items: center;
`,c=r.div`
  margin: 0 0 0 16px;
`,s=()=>{const{t:r}=i();return o(n,{children:t(m,{children:[o("img",{alt:r("imgAlt.androidBlockIcon"),src:e}),o(c,{children:r("common.block")})]})})};export{s as BlockSection};
//# sourceMappingURL=BlockSection.js.map
